import GlobalVariable from '@/global/global-variable'
import ApiFileLocal from "./api-file-local";

// 上传解析视频文件
const uploadVideoFileApi = GlobalVariable.BASE_PATH + "/rest/camera/upload";

// 添加视频
const addVideoApi = GlobalVariable.BASE_PATH + "/rest/camera/add";

// 编辑视频配置
const updateVideoConfigApi = GlobalVariable.BASE_PATH + "/rest/camera/updateConfig";

// 编辑视频坐标
const updateVideoPointApi = GlobalVariable.BASE_PATH + "/rest/camera/updatePoint";

// 开启/关闭视频
const openVideoApi = GlobalVariable.BASE_PATH + "/rest/camera/updateStatus";

// 删除视频
const deleteVideoApi = GlobalVariable.BASE_PATH + "/rest/camera/delete";

// 批量删除视频
const deleteBatchVideoApi = GlobalVariable.BASE_PATH + "/rest/camera/deleteBatch";

// 查询视频信息
const searchVideoApi = GlobalVariable.BASE_PATH + "/rest/camera/search";

// 查询视频信息
const exportVideoApi = GlobalVariable.BASE_PATH + "/rest/camera/export";

// 修改状态
const updateStatusApi = GlobalVariable.BASE_PATH + "/rest/camera/updateStatus";

// 修改状态
const deleteRegionApi = GlobalVariable.BASE_PATH + "/rest/camera/deleteRegion";

export default {
    uploadVideoFileApi,
    addVideoApi,
    updateVideoConfigApi,
    updateVideoPointApi,
    openVideoApi,
    deleteVideoApi,
    deleteBatchVideoApi,
    searchVideoApi,
    exportVideoApi,
    updateStatusApi,
    deleteRegionApi,
    videoUploadModel: ApiFileLocal.file_video_upload_model
}



// WEBPACK FOOTER //
// ./src/request/api-video.js